// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3swPX","name":"ConsentHeader_name__3yslI","birthday":"ConsentHeader_birthday__1nJAt","skeleton":"ConsentHeader_skeleton__2PCud"};